import React from 'react';
import Loading from '../../../shared/loading';
import defaultOnErrorHandler from '../../../shared/default-on-error-handler';
import ErrorBoundary from '../../../shared/error-boundary';
import LivewireEventOrder from './livewire-event-order';
import LinkLivewireEventOrderModal from './link-livewire-event-order-modal';
import { getUnlinkedOrders } from '../../../services/lwadmin/livewire-events/events-service';

export default class UnlinkedOrdersTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      orders: [],
    };
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    this.loading.start();
    getUnlinkedOrders()
      .then(r => this.setState({ orders: r.data.orders.map(e => new LivewireEventOrder(e)) }))
      .catch(e => defaultOnErrorHandler(e, 'Error loading unlinked orders'))
      .finally(() => this.loading.stop());
  }

  linkOrder(e, order) {
    e && e.preventDefault && e.preventDefault();

    this.linkLivewireEventOrderModal.present(order);
  }

  render() {
    return (
      <ErrorBoundary>
        <div className="lwadmin-livewire-events-unlinked-orders-table">
          <Loading ref={c => (this.loading = c)}>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Order number</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Ticket type</th>
                  <th>Tools</th>
                </tr>
              </thead>
              <tbody>
                {this.state.orders.map(order => (
                  <tr key={order.id}>
                    <td>{order.order_number}</td>
                    <td>{order.name}</td>
                    <td>{order.email}</td>
                    <td>{order.ticket_type}</td>
                    <td className="table-tools">
                      <ul>
                        <li><a href="#" onClick={e => this.linkOrder(e, order)}>Link</a></li>
                      </ul>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Loading>
        </div>
        <LinkLivewireEventOrderModal
          ref={c => (this.linkLivewireEventOrderModal = c)}
          orderDidSave={() => this.refresh()}
        />
      </ErrorBoundary>
    );
  }
}
